// Jquery - jQuery is a popular and feature-rich JavaScript library. Learn more: https://jquery.com/
window.jQuery = window.$ = require('jquery');

// Bootstrap - The most popular framework uses as the foundation. Learn more: http://getbootstrap.com
window.bootstrap = require('bootstrap');

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
window.Popper = require('@popperjs/core');

// Wnumb - Number & Money formatting. Learn more: https://refreshless.com/wnumb/
window.wNumb = require('wnumb');

window.KTUtil = require('@/js/components/util.js');
window.KTCookie = require('@/js/components/cookie.js');
window.KTDialer = require('@/js/components/dialer.js');
window.KTDrawer = require('@/js/components/drawer.js');
window.KTEventHandler = require('@/js/components/event-handler.js');
window.KTEventHandler = require('@/js/components/event-handler.js');
window.KTFeedback = require('@/js/components/feedback.js');
window.KTImage = require('@/js/components/image-input.js');
window.KTMenu = require('@/js/components/menu.js');
window.KTPasswordMeter = require('@/js/components/password-meter.js');
window.KTPlace = require('@/js/components/place.js');
window.KTScroll = require('@/js/components/scroll.js');
window.KTScrolltop = require('@/js/components/scrolltop.js');
window.KTSearch = require('@/js/components/search.js');
window.KTStepper = require('@/js/components/stepper.js');
window.KTSticky = require('@/js/components/sticky.js');
window.KTToggle = require('@/js/components/toggle.js');

//Layout
window.KTLayoutAside = require('@/js/layout/aside.js');
window.KTLayoutSearch = require('@/js/layout/search.js');
window.KTLayoutToolbar = require('@/js/layout/toolbar.js');

window.KTApp = require('@/js/layout/app.js');

window.initializeKT = function () {
    setTimeout(function () {
        window.KTUtil.init();
        window.KTDialer.init();
        window.KTToggle.init();
        window.KTLayoutAside.init();
        window.KTDrawer.init();
        window.KTPlace.init();
        window.KTScroll.init();
        window.KTScrolltop.init();
        window.KTImage.init();
        window.KTSticky.init();
        window.KTApp.init();
        window.KTMenu.init();
    }, 500);
}
